import { LongPressOptions } from 'use-long-press';

export const USE_LONG_PRESS_OPTIONS: LongPressOptions = { cancelOnMovement: 3 };
Object.freeze(USE_LONG_PRESS_OPTIONS);
